export function readFilterQuery (search, key) {

  try {

    const params = new URLSearchParams(search || '')
    const raw = params.get(key)

    if (!raw) return null

    const parsed = JSON.parse(decodeURIComponent(raw))

    if (!parsed || !Array.isArray(parsed.filters)) return null

    return {
      filters: parsed.filters,
      matchMode: parsed.matchMode || 'all'
    }
  } catch (err) {

    return null
  }
}

export function filterQueryHref (href, key, payload) {

  const url = new URL(href)

  if (payload) {

    url.searchParams.set(key, encodeURIComponent(JSON.stringify(payload)))
  } else {

    url.searchParams.delete(key)
  }

  return `${url.pathname}${url.search}${url.hash}`
}
